import { CCardGroup } from '@coreui/react-pro'
import React from 'react'

const ConfiaCarCardGroup = (props) => {
  const { children } = props
  return <CCardGroup {...props}>{children}</CCardGroup>
}

export { ConfiaCarCardGroup }
